import { render, staticRenderFns } from "./ProductCommentReply.vue?vue&type=template&id=1f0fe8d2&"
import script from "./ProductCommentReply.js?vue&type=script&lang=js&"
export * from "./ProductCommentReply.js?vue&type=script&lang=js&"
import style0 from "./ProductCommentReply.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports